import { FC } from "react"
const Footer: FC = () => {
    return (
        <footer className="mx-auto grid place-content-center p-1 md:p-4 mb-14 md:mb-1">
            <ul>
                <li className="text-center font-semibold text-red-500 underline underline-offset-2">
                    Note:
                </li>
                <li>🐻‍❄️- Runs on Devnet.</li>
                <li>👽- Switch your wallet network to devnet.</li>
            </ul>
            <h3>🐸- Reach out to me @ X | Tweeter: Click 👉 : <a className="underline underline-offset-2 text-blue-400" target="_blank" href="https://twitter.com/Abhishek_Tech_">Abhishek</a></h3>


        </footer>
    )
}

export default Footer